import React from "react";
import "./Hotel.css";
import WaitingFor from "components/Banner/WaitingFor";

// Images
import Hotel from "images/goopter-use-case-hotel-service-automation.jpg";
import GoopterHotel from "images/goopter-use-case-hotel-service-automation-process.png";
import HighlightsRight from "images/goopter-use-case-hotel-service-automation-highlights.jpg";
import HighlightsLeft from "images/hotel/goopter-hotel-service-automation-robots-features.png";
// Background Images
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import { Link } from "react-router-dom";
import OtherUseCases from "components/Banner/UsecasesBanner";

import { FormattedMessage } from "react-intl";

export default function Index() {
  return (
    <>
      <div className="hotel-page">
        <section className="banner">
          <RightBox className="right-bg mobile" />
          <LeftBox className="left-bg mobile" />
          <div className="image-box">
            <img
              src={Hotel}
              className="hotel-img"
              alt="goopter use case hotel"
            />
            <div className="col-lg-12 text-box">
              <div className="col-lg-6 col-sm-12 left-title">
                <h1>
                  <FormattedMessage id={"use_case_hotel_page_intro_title"} />
                </h1>
              </div>
              <div className="col-lg-6 col-sm-12 right-text">
                <p className="desc1">
                  <FormattedMessage
                    id={"usecase_hotel_service_automation_text1"}
                  />
                </p>
                <p className="desc2">
                  <FormattedMessage
                    id={"usecase_hotel_service_automation_text2"}
                  />
                </p>
                <p className="desc2">
                  <FormattedMessage
                    id={"usecase_hotel_service_automation_text3"}
                  />
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="main-background">
          <section className="introduction container row mx-auto">
            <div className="col-lg-12 intro-box">
              <p className="desc1">
                <FormattedMessage id={"use_case_hotel_page_header_text1"} />
              </p>
              <p className="desc2">
                <FormattedMessage id={"use_case_hotel_page_header_text2"} />
              </p>
            </div>
          </section>
          <section className="goopter-hotel row mx-auto">
            <RightBox className="right-bg" />
            <LeftBox className="left-bg" />
            <div className="col-lg-12 intro-box">
              <h2>
                <FormattedMessage id={"use_case_hotel_page_intro_title"} />
              </h2>
              <div className="img-box col-lg-8">
                <img
                  src={GoopterHotel}
                  alt="self-serve ordering &amp; delivery automation"
                />
              </div>
            </div>
          </section>
          <section className="highlights">
            <LeftBox className="left-bg" />
            <div className="container row mx-auto">
              <h2>
                <FormattedMessage id={"highlights_of_the_features"} />
              </h2>
              <div className="col-lg-12 contents">
                <div className="col-lg-5 col-sm-12 left-box">
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights1_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights1_text"}
                    />
                  </p>
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights2_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights2_text"}
                    />
                  </p>
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights3_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_highlights3_text"}
                    />
                  </p>
                  <div className="btn green-button">
                    <Link to="/request-a-demo">
                      <FormattedMessage id={"learn_more"} />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 col-sm-12 right-box">
                  <div className="white-box">
                    <h6>
                      <FormattedMessage id={"benefits"} />
                    </h6>
                    <ul>
                      <li>
                        <FormattedMessage
                          id={"use_case_hotel_page_benefits_text1"}
                        />
                      </li>
                      <li>
                        <FormattedMessage
                          id={"use_case_hotel_page_benefits_text2"}
                        />
                      </li>
                      <li>
                        <FormattedMessage
                          id={"use_case_hotel_page_benefits_text3"}
                        />
                      </li>
                    </ul>
                  </div>
                  <img src={HighlightsRight} alt="ordering highlights" />
                </div>
              </div>
              <div className="col-lg-12 contents2">
                <div className="col-lg-7 col-sm-12 left-box">
                  <img src={HighlightsLeft} alt="highlighted hardwares" />
                </div>
                <div className="col-lg-5 col-sm-12 right-box">
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature1_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature1_text"}
                    />
                  </p>
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature2_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature2_text"}
                    />
                  </p>
                  <h5>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature3_title"}
                    />
                  </h5>
                  <p>
                    <FormattedMessage
                      id={"use_case_hotel_page_feature3_text"}
                    />
                  </p>
                  <div className="btn green-button">
                    <Link to="/request-a-demo">
                      <FormattedMessage id={"learn_more"} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <OtherUseCases except="Hotel Service Automation" />
        </div>
        <WaitingFor />
      </div>
    </>
  );
}
